export enum EPidApiKey {
  MPID = 'MPID',
  NSPID = 'NSPID',
  SPID = 'SPID',
}
